// Shared by the popup sheet (popups.js) and the form launcher's phone sheet (launcher.js).
// Drag the mobile sheet down from anywhere on it, as the ordering sheets do: the drag takes over only while
// the sheet is scrolled to the top, and past a quarter of its height (160px at most) it closes, else it
// snaps back. The grab bar only shows on the sheet, so it doubles as the "is this a sheet" check. scroller: the
// element that scrolls, when it is not the sheet itself (a sheet with a fixed header and footer).
export function wireSwipe(grab, dialog, onDismiss, scroller = dialog) {
  let startY = null
  let delta = 0
  let engaged = false
  const reset = () => { dialog.style.transition = ''; dialog.style.transform = '' }
  const onStart = (event) => {
    if (getComputedStyle(grab).display === 'none' || scroller.scrollTop > 0) return
    startY = event.touches[0].clientY
    delta = 0
    engaged = false
  }
  const onMove = (event) => {
    if (startY == null) return
    delta = event.touches[0].clientY - startY
    if (!engaged) {
      if (delta <= 0 || scroller.scrollTop > 0) { startY = null; return }
      engaged = true
      dialog.style.transition = 'none'
    }
    event.preventDefault()
    dialog.style.transform = `translateY(${Math.max(0, delta)}px)`
  }
  const onEnd = () => {
    if (startY == null) return
    startY = null
    if (!engaged) return
    // Clearing the drag and closing in the same frame lets the CSS exit carry on from where the finger let go.
    reset()
    if (delta > Math.min(dialog.offsetHeight * 0.25, 160)) onDismiss()
  }
  dialog.addEventListener('touchstart', onStart, { passive: true })
  dialog.addEventListener('touchmove', onMove, { passive: false })
  dialog.addEventListener('touchend', onEnd)
  dialog.addEventListener('touchcancel', onEnd)
  return () => {
    dialog.removeEventListener('touchstart', onStart)
    dialog.removeEventListener('touchmove', onMove)
    dialog.removeEventListener('touchend', onEnd)
    dialog.removeEventListener('touchcancel', onEnd)
  }
}
